import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import HumburgerMenu from "../pages/layout/sidebar";
import { sidebarDrawerInit, getCookies, deleteCookies } from "../helper/utils";
import { openRoutes } from "./route-list";
import NotFound from "../pages/not-found";

import Chat from "../pages/chat";
import Loader from "../components/common/loader";

export const ThemeContext = createContext();
export const GameContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const PrivateRoute = ({ path, element, isAuthProtected }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getCookies("xcasino_token");
  const [menuOpen, setMenuOpen] = useState(sidebarDrawerInit ? false : true);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [toggleShow, setToggleShow] = useState(true);
  const { innerWidth: width, innerHeight: height } = window;

  const drawerWidth = "250px";
  const drawerPadding = "78px";

  let forSmallScreen = menuOpen ? drawerWidth : "0px";
  let forLargeScrren = menuOpen ? drawerWidth : "61px";

  let forSmallScreen1 = menuOpen ? drawerPadding : "80px";
  let forLargeScrren1 = menuOpen ? drawerPadding : "50px";
  let forNediumScrren1 = "78px";

  let newMargin = location.pathname === "/game-section" ? "0px" :  width <= 768 ? forSmallScreen : forLargeScrren;

  let newPedding =
    width <= 768
      ? forSmallScreen1
      : width <= 1024
      ? forNediumScrren1
      : forLargeScrren1;

  const [theme, setTheme] = useState("Dark");
  const [gameSearch, setGameSearch] = useState("");

  const {
    loading,
    error: profileError,
    data: profileData,
  } = useSelector((state) => state.getProfile);

  useEffect(() => {
    console.log("path", path);
    if (path === "") {
    } else {
      if (isAuthProtected && !auth) {
        setIsRedirecting(true);
        toast.error("Authentication required");

        setTimeout(() => {
          navigate("/signin-username");
          setIsRedirecting(false);
        }, 500);
      }
    }
  }, []);

  // On mount, check for a saved theme in localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute("data-theme", savedTheme);
    }
  }, []);

  // Switch the theme and store it in localStorage
  const toggleTheme = (data) => {
    const newTheme = data === "Light" ? "Dark" : "Light";
    setTheme(data);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", data); // Store theme in localStorage
  };


  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const vpnToken = params.get("vpnToken");

  if (vpnToken) {
    localStorage.setItem("vpnToken", vpnToken);
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
}, [location.search]);

  useEffect(() => {
    const root = document.documentElement;

    if (theme === "Dark") {
      console.log("Dark");
      root.classList.add("dark-theme");
      root.classList.remove("light-theme");
    } else {
      console.log("Light");
      root.classList.add("light-theme");
      root.classList.remove("dark-theme");
    }
  }, [theme]);

  if (isRedirecting) {
    return <Loader />;
  }

  const newTransation = location.pathname == "/game-section" ? "none" : "all 0.3s ease";


  

  return (
    <div className=" h-100">
      <ThemeContext.Provider
        value={{ theme, toggleTheme, gameSearch, setGameSearch }}
      >
        {/* {MemoizedSidebar} */}
        {!openRoutes.some((route) => route.path === path) && (
          <>
            {location.pathname !== "/game-section" && (
              <HumburgerMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            )}
            {/* <Chat /> */}
          </>
        )}

        <div className={"page-wrap h-100"}>
          {path == "*" && <NotFound />}

          {window.innerWidth > 768 ? (
            <div
              className="h-100"
              style={
                !openRoutes.some((route) => route.path === path)
                  ? {
                      marginLeft: newMargin,
                      paddingTop: profileData?.user?.isDemoUser
                        ? "90px"
                        : "78px", // newPedding,
                      transition: "none"   // "all 0.5s ease",
                    }
                  : {}
              }
            >
              {element}
            </div>
          ) : (
            <div
              className="h-100 "
              style={
                !openRoutes.some((route) => route.path === path)
                  ? {
                      marginTop: profileData?.user?.isDemoUser
                        ? "130px" : width <= 768 ? "178px"
                        : "100px",
                    }
                  : {}
              }
            >
              {element}
            </div>
          )}
        </div>
      </ThemeContext.Provider>
    </div>
  );
};

export default PrivateRoute;
